import { CWElementsConfig, useConfig } from '@cw-elements/config';
import { loadRemoteModule } from '@cw-elements/mfe-setup/load';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Button, ButtonType, Tooltip, Typography } from 'syngenta-digital-cropwise-react-ui-kit';
import TextArea from 'antd/es/input/TextArea';
const { Text } = Typography;

interface PrescriptionExporterProps {
  getConfigInstance: () => CWElementsConfig;
  userLanguage: string;
  orgId: string;
  agOperationIds: () => string[];
  onClose: () => void;
  isOpen: boolean;
  orgCountry: string;
}

export const PrescriptionExporter: React.FC<{ orgId: string }> = ({ orgId }: { orgId: string }) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [agOperationIdsInput, setAgOperationIdsInput] = React.useState<string>(
    'd62b173a-2262-4211-bcf5-f6e6a8649ba4',
  );

  const PrescriptionExporter = React.lazy<React.FC<PrescriptionExporterProps>>(() =>
    loadRemoteModule('connect-files/prescription-exporter'),
  );

  return (
    <div>
      <Text className="justify-center">Ag Operation IDs (comma-separated)</Text>
      <TextArea
        className="w-360px"
        rows={4}
        defaultValue="d62b173a-2262-4211-bcf5-f6e6a8649ba4"
        onChange={(e) => setAgOperationIdsInput(e.target.value)}
        placeholder="Enter comma-separated list of Ag Operation IDs"
      />
      <Tooltip title={!agOperationIdsInput ? 'Please enter at least one Ag Operation ID' : ''}>
        <div>
          <Button
            className="m-20"
            disabled={!agOperationIdsInput}
            type={ButtonType.primary}
            onClick={() => setIsModalOpen(true)}
          >
            Open Exporter
          </Button>
        </div>
      </Tooltip>
      <ErrorBoundary fallback={<span />}>
        <React.Suspense fallback={<span />}>
          <PrescriptionExporter
            getConfigInstance={useConfig}
            userLanguage="en"
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            agOperationIds={() => agOperationIdsInput.split(',').map((id) => id.trim())}
            orgId={orgId}
            orgCountry="US"
          />
        </React.Suspense>
      </ErrorBoundary>
    </div>
  );
};
